module.exports = __webpack_public_path__ + "img/warning.70584b7a.gif";